import {
  LayerSubLayers,
  LayerTypes,
  SubLayerTypes,
} from '@constants/canvas/layers';
import LayerViewBase from '@utils/canvas/LayerViewBase';

/**
 * Read model for one layer element. Heights are derived from node data by
 * layerHeights.computeCanvasGeometry and rendered through the node's data.height.
 */
class LayerView extends LayerViewBase<LayerTypes> {
  get subLayerIds(): SubLayerTypes[] {
    return LayerSubLayers[this.id];
  }

  static isLayer<T extends string>(id: T) {
    return Object.hasOwn(LayerSubLayers, id);
  }
}

export default LayerView;
